import React, { Component } from "react";
import NavBarHome from "../Components/NavBarHome";
import "./home.css";
import discordlogo from "./discordlogo.png"
import loglink from "./loglink.png"
import demoad from "./sunmoonad.png"

class Home extends Component {

    render() {
        return (
            <>
                <NavBarHome/>
                <div className="demoad">
                        <a href="https://blastcatsdev.itch.io/blastcatssunmoon"><img src= {demoad} alt="Go to Demo!"></img></a>
                        <div className="wrapper-wrapper">
                                <div className="player-wrapper">
                                    <iframe 
                                        className="vid"
                                        src="https://www.youtube.com/embed/AssE0EWUwI0"
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                </div>
                <div className="centerbox"></div>
                
                <div className="homeLinks">
                    
                    <div className="homeLinkBox">
                        Wishlist the game!
                        <iframe src="https://store.steampowered.com/widget/2007430/" frameBorder="0" width="100%" height="100%" title="Steam Widget"></iframe>
                    </div>
                    <div className="homeLinkBox">
                        Join the community!
                        <a href="https://discord.gg/WYn526c8ch"><img src={discordlogo} width="80%" alt="Discord"></img></a>
                    </div>
                    <div className="homeLinkBox">
                        What's new on the Dev Log?
                        <a href="/blog"><img src={loglink} width="50%" alt="Dev Log"></img></a>
                    </div>
                </div>
                
                
                
            </>
        )
    }
}

export default Home;
